import React from 'react';

function Check(props: { size?: number; color?: string } & React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={props.size} height={props.size ? (props.size * 13) / 17 : undefined} viewBox="0 0 17 13">
            <path
                fill={props.color}
                fillRule="evenodd"
                stroke={props.color}
                strokeWidth=".786"
                d="M6.091 12a.927.927 0 0 1-.662-.278L1.275 7.51a.962.962 0 0 1 0-1.346.928.928 0 0 1 1.325 0L6.09 9.702l8.31-8.424a.927.927 0 0 1 1.325 0 .962.962 0 0 1-.001 1.347l-8.971 9.096A.927.927 0 0 1 6.09 12"
            />
        </svg>
    );
}

export default Check;
